"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.detectTypes = detectTypes;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/*
 * adds some type annotations to the autoSql schema
 * for numeric fields ['uint', 'int', 'float', 'long'] "isNumeric" is added
 * for array types "isArray" is added
 * for numeric array types "isArray" and "arrayIsNumeric" is set
 *
 * @param autoSql - an autoSql schema from the peg parser
 * @return autoSql with type annotations added
 */
function detectTypes(autoSql) {
  var numericTypes = ['uint', 'int', 'float', 'long'];
  var fields = autoSql.fields.map(function (autoField) {
    var type = {};

    if (!autoField.size && numericTypes.includes(autoField.type)) {
      type.isNumeric = true;
    }

    if (autoField.size && autoField.type !== 'char') {
      type.isArray = true;
    }

    if (autoField.size && numericTypes.includes(autoField.type)) {
      type.arrayIsNumeric = true;
    }

    return _objectSpread(_objectSpread({}, autoField), type);
  });
  return _objectSpread(_objectSpread({}, autoSql), {}, {
    fields: fields
  });
}